module.exports = __webpack_public_path__ + "img/step1-c.4608819c.png";